import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HashRouter } from "react-router-dom";
import Login from "./Login/Login";
import Register from "./Login/Register";

const AppWrapper = () => {
  const loggedIn = localStorage.getItem("loggedIn") === "true";
  const path = window.location.hash.replace("#", "") || "/";

  return (
    <HashRouter>
      {!loggedIn ? (
        path === "/" || path === "" ? (
          <Login />
        ) : path === "/register" ? (
          <Register />
        ) : (
          (() => {
            window.location.hash = "/";
            return null;
          })()
        )
      ) : (
        <App />
      )}
    </HashRouter>
  );
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWrapper />
    <ToastContainer />
  </React.StrictMode>
);
